import React from "react";

const ButtonClose = ({onClick}) => {
  return (
    <button
    onClick={onClick}
      type="button"
      aria-label=""
      className="swal2-confirm swal2-styled bg-[#dd3333] inline-block  m-1 py-2 px-8 shadow-none font-medium border-x-[#dd3333] text-[1.0625em] rounded-[0.25em] text-darkTextColor w-44"
    >
      Cancel
    </button>
  );
};

export default ButtonClose;
